import { VisitMethods } from 'constants/VisitMethods';

export const getVisitPopUpTitle = (method?: string): string => {
  if (method === VisitMethods.ASYNCHRONOUS) return 'Review';
  if (method === VisitMethods.INPERSON) return 'In-person visit';
  return 'Visit';
};
